// Pattern from:
// https://dev.to/sanjayttg/jwt-authentication-in-react-with-react-router-1d03

// This allows our children components to import and use the state of [token] and [role].

import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { normalizeRole } from "../helper/auth";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const [token, setToken_] = useState(null);
  const [role, setRole_] = useState(null);
  const [userFirstName, setUserFirstName_] = useState(null);
  const [userLastName, setUserLastName_] = useState(null);
  const [userEmail, setUserEmail_] = useState(null);

  const setToken = useCallback((newToken) => {
    setToken_(newToken);
  }, []);

  const setRole = useCallback((newRole) => {
    setRole_(normalizeRole(newRole));
  }, []);

  const setUserFirstName = useCallback((newFirstName) => {
    setUserFirstName_(newFirstName);
  }, []);

  const setUserLastName = useCallback((newLastName) => {
    setUserLastName_(newLastName);
  }, []);

  const setUserEmail = useCallback((newEmail) => {
    setUserEmail_(newEmail);
  }, []);

  useEffect(() => {
    // Token, role, and names are no longer synced to localStorage for security bounds.
  }, [token]);

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
      role,
      setRole,
      userFirstName,
      setUserFirstName,
      userLastName,
      setUserLastName,
      userEmail,
      setUserEmail,
    }),
    [
      role,
      setRole,
      setToken,
      setUserEmail,
      setUserFirstName,
      setUserLastName,
      token,
      userEmail,
      userFirstName,
      userLastName,
    ]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
